!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("isomorphic-fetch")) : "function" == typeof define && define.amd ? define("egClickstream", ["isomorphic-fetch"], t) : "object" == typeof exports ? exports.egClickstream = t(require("isomorphic-fetch")) : e.egClickstream = t(e["isomorphic-fetch"]);
}(this, function (e) {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 2);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t) {
    var r = {
        d: (e, t) => {
          for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
          });
        },
        o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
        r: e => {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }
      },
      n = {};
    r.r(n), r.d(n, {
      EventPacker: () => i
    });
    var o = new RegExp("^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)(?:-((?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\\+([0-9a-zA-Z-]+(?:\\.[0-9a-zA-Z-]+)*))?$"),
      i = function () {
        function e() {}
        return e.prototype.packEvent = function (e) {
          return this.packEvents([e]);
        }, e.prototype.packEvents = function (e) {
          var t = this,
            r = new Map();
          e.forEach(function (e) {
            var n;
            try {
              var o = JSON.parse(e),
                i = o.event.event_name,
                a = o.event.event_version,
                c = t.getMajorVersion(a);
              if (!i || !c) return;
              var u = null !== (n = r.get(i)) && void 0 !== n ? n : new Map(),
                l = {
                  event_data: o
                };
              u.set(c, l), r.set(i, u);
            } catch (t) {
              console.error("Failed to pack event: ".concat(e, " \n ").concat(t));
            }
          });
          var n = {
            metadata: {
              packer_version: "1.0.5"
            },
            events: this.convertMapToObj(r)
          };
          return JSON.stringify(n);
        }, e.prototype.unpack = function (e, t, r) {
          var n, o;
          try {
            var i = JSON.parse(e).events,
              a = this.getMajorVersion(r);
            console.debug("Find the event for: event_name: ".concat(t, " \t event_version: ").concat(r, " \t"));
            var c = void 0;
            return null != a && (c = null === (o = null === (n = null == i ? void 0 : i[t]) || void 0 === n ? void 0 : n[a]) || void 0 === o ? void 0 : o.event_data), console.debug("eventData: ".concat(c)), c ? JSON.stringify(c) : null;
          } catch (t) {
            return console.error("Failed to unpack event payload: ".concat(e)), null;
          }
        }, e.prototype.getMajorVersion = function (e) {
          if (!e) return null;
          var t = function (e) {
            var t = e.match(o);
            return t && t.length > 2 ? t[1] : null;
          }(e);
          return t ? "v".concat(t) : null;
        }, e.prototype.convertMapToObj = function (e) {
          var t = this;
          return Object.fromEntries(Array.from(e.entries(), function (e) {
            var r = e[0],
              n = e[1];
            return n instanceof Map ? [r, t.convertMapToObj(n)] : [r, n];
          }));
        }, e;
      }();
    t.EventPacker = n.EventPacker, Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, r) {
    "use strict";

    function n(e, t, r) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" !== o(e) || null === e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" !== o(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" === o(t) ? t : String(t);
      }(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function o(e) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function i(e) {
      if (!a(e)) return !1;
      for (var t = 0, r = arguments.length <= 1 ? 0 : arguments.length - 1; t < r; t++) if (!e.hasOwnProperty(t + 1 < 1 || arguments.length <= t + 1 ? void 0 : arguments[t + 1])) return !1;
      return !0;
    }
    function a(e) {
      return "object" === o(e) && null !== e && Object.getPrototypeOf(e) === Object.prototype;
    }
    function c(e) {
      for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) r[o - 1] = arguments[o];
      if (!r.length) return e;
      var i = r.shift();
      if (a(e) && a(i)) for (var u in i) if (a(i[u])) e[u] || Object.assign(e, n({}, u, {})), c(e[u], i[u]);else {
        var l = i[u];
        null != l && Object.assign(e, n({}, u, l));
      }
      return c.apply(void 0, [e].concat(r));
    }
    function u() {
      return "undefined" == typeof window ? {} : window;
    }
    function l() {
      var e = u();
      return Math.round(e.innerHeight) || 0;
    }
    function s() {
      return Math.round(((e = u().screen) && e.width || 0) * v());
      var e;
    }
    function f() {
      return Math.round(((e = u().screen) && e.height || 0) * v());
      var e;
    }
    function v() {
      return u().devicePixelRatio || 0;
    }
    r.r(t), r.d(t, "instance", function () {
      return W;
    });
    var p = "/egcs/v2/collect",
      y = ["event", "experience"],
      d = ["event_version", "event_name", "event_type"],
      h = ["page_name", "app_name", "app_version"],
      b = "onInvalidPayload",
      m = "onPublishError",
      g = "onFetchError",
      _ = r(0),
      S = r.n(_);
    function w(e) {
      return (w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function k(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, i = function (e, t) {
          if ("object" !== w(e) || null === e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" !== w(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        }(o, "string"), "symbol" === w(i) ? i : String(i)), n);
      }
      var o, i;
    }
    function E(e, t, r) {
      S()(p, {
        method: e,
        headers: {
          "Content-Type": "application/json",
          Connection: "keep-alive"
        },
        referrerPolicy: "origin-when-cross-origin",
        mode: "same-origin",
        credentials: "same-origin",
        cache: "no-cache",
        redirect: "follow",
        keepalive: !0,
        body: JSON.stringify(t)
      }).then(function (e) {
        e.status >= 400 && r(new Error("Error on fetch ".concat(p, " with ").concat(e.status, " error code.")), g);
      }).catch(function (e) {
        r(new Error("Error on fetch ".concat(p, ". ").concat(e)), g);
      });
    }
    var P = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      }
      var t, r, n;
      return t = e, n = [{
        key: "logError",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "EgClickstream",
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : console;
          e && r.error("".concat(t, " - ").concat(e.toString()));
        }
      }, {
        key: "postJson",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : console.error;
          E("POST", e, t);
        }
      }], (r = null) && k(t.prototype, r), n && k(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }();
    function j(e) {
      return (j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function O(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, i = function (e, t) {
          if ("object" !== j(e) || null === e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" !== j(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        }(o, "string"), "symbol" === j(i) ? i : String(i)), n);
      }
      var o, i;
    }
    var x = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._isScheduled = !1, this._batchQueue = [], this._processEvents = this._processEvents.bind(this);
      }
      var t, r, n;
      return t = e, (r = [{
        key: "publish",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : console;
          a(e) && (this._batchQueue.push(e), this._scheduleAsyncProcessing(t));
        }
      }, {
        key: "_scheduleAsyncProcessing",
        value: function (e) {
          var t, r;
          this._isScheduled || (this._isScheduled = !0, t = this._processEvents(e), "requestIdleCallback" in (r = u()) ? r.requestIdleCallback(t) : setTimeout(t, 0));
        }
      }, {
        key: "_processEvents",
        value: function (e) {
          var t = this;
          return function () {
            P.postJson(t._batchQueue, e), t._batchQueue = [], t._isScheduled = !1;
          };
        }
      }]) && O(t.prototype, r), n && O(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }();
    function M() {
      return new x();
    }
    var C = r(1);
    function T(e) {
      return (T = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function A(e) {
      return function (e) {
        if (Array.isArray(e)) return N(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return N(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return N(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function N(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function J(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function q(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, i = function (e, t) {
          if ("object" !== T(e) || null === e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" !== T(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        }(o, "string"), "symbol" === T(i) ? i : String(i)), n);
      }
      var o, i;
    }
    var I = {
        onFetchError: function () {},
        onPublishError: function () {},
        onInvalidPayload: function () {}
      },
      W = new (function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : I,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          J(this, e), this.context = r.initialContext, this.publisher = M(), this.callbacks = t, this.unpacker = new C.EventPacker();
        }
        var t, r, n;
        return t = e, (r = [{
          key: "getNewInstance",
          value: function (e, t) {
            return new this.constructor(e, t);
          }
        }, {
          key: "publish",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              r = this._createPayload(e, t);
            if (this._isValidPayload(r)) try {
              this.publisher.publish(r, this._logErrorWithEmit.bind(this));
            } catch (e) {
              this._logErrorWithEmit(e, m);
            } else this._logErrorWithEmit(new Error("publish failed due to invalid payload: ".concat(JSON.stringify(r))), b);
          }
        }, {
          key: "updateContext",
          value: function (e) {
            this.context = c({}, this.context, e);
          }
        }, {
          key: "_logErrorWithEmit",
          value: function (e, t) {
            "function" == typeof this.callbacks[t] && this.callbacks[t](e);
            var r = {
              error: function (e) {
                console.error(e);
              }
            };
            P.logError(e, void 0, r);
          }
        }, {
          key: "_createPayload",
          value: function (e, t) {
            return this._enrichContext(), c({}, this._unpackServerPayload(t, e), e, this.context, this._getClickstreamOverrides());
          }
        }, {
          key: "_unpackServerPayload",
          value: function (e, t) {
            var r,
              n = t && t.event,
              o = n && n.event_name,
              i = n && n.event_version;
            if (e && o && i) {
              try {
                var a = this.unpacker.unpack(e, o, i);
                a || this._logErrorWithEmit(new Error("Unable to find a matching server payload for the provided [event_name]: ".concat(o, " \t [event_version]: ").concat(i, " \t [serverPayload]: ").concat(e)), b), r = JSON.parse(a);
              } catch (e) {
                this._logErrorWithEmit(e, b);
              }
              return r;
            }
          }
        }, {
          key: "_enrichContext",
          value: function () {
            this.context = c({}, this.context, this._getRequestContext(), this._getTimestamps(), this._getExperience());
          }
        }, {
          key: "_getTimestamps",
          value: function () {
            return {
              timestamps: {
                event_origination_timestamp: Date.now()
              }
            };
          }
        }, {
          key: "_getRequestContext",
          value: function () {
            return {
              request: {
                request_url: (t = u().location, t && t.href || void 0),
                referrer_url: (e = u().document, e && e.referrer || void 0)
              }
            };
            var e, t;
          }
        }, {
          key: "_getExperience",
          value: function () {
            return {
              experience: {
                experience_type: "Web",
                viewport_width: (e = u(), Math.round(e.innerWidth) || 0),
                viewport_height: l(),
                resolution_width: s(),
                resolution_height: f()
              }
            };
            var e;
          }
        }, {
          key: "_getClickstreamOverrides",
          value: function () {
            var e = u().eg_clickstream_overrides;
            return e ? {
              identifiers: {
                device_user_agent_id: e.device_user_agent_id
              },
              device_information: {
                device_type: e.device_type,
                device_os: e.device_os,
                device_os_version: e.device_os_version
              },
              experience: {
                experience_type: e.experience_type,
                experience_platform: e.experience_platform
              },
              user: {
                brand_customer_id: e.brand_customer_id
              }
            } : {};
          }
        }, {
          key: "_isValidPayload",
          value: function (e) {
            return i.apply(void 0, [e].concat(A(y))) && i.apply(void 0, [e.event].concat(A(d))) && i.apply(void 0, [e.experience].concat(A(h)));
          }
        }]) && q(t.prototype, r), n && q(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }())();
  }]);
});